import { useState } from 'react';

import { ifLinks, mmLinks } from 'constants/links';
import useGlobalStore from 'hooks/useGlobalStore';
import profileStyles from 'pages/account/Profile/styles';

function Email({ email }) {
    const { isMisfitsTheme } = useGlobalStore();
    const [isEditing, setIsEditing] = useState(false);

    return (
        <div className={profileStyles.displayContainer}>
            <div className="w-0 flex-1">
                <h4 className="text-body-md font-grotesk-bold">Email address</h4>
                <p className="mt-10 truncate">{email}</p>
                {isEditing && (
                    <p className="text-body-sm my-15 pr-80">
                        If you need to make changes to your email address, please contact{' '}
                        <a
                            href={isMisfitsTheme ? mmLinks.customerCare : ifLinks.customerCare}
                            target="_blank"
                            className="link"
                            rel="noopener noreferrer"
                        >
                            Customer Care.
                        </a>
                    </p>
                )}
                <p className="mt-10">
                    <a href="/login/forgot-password" className="link text-body-sm">
                        Reset my password
                    </a>
                </p>
            </div>
            {!isEditing && (
                <button className={profileStyles.edit} type="button" onClick={() => setIsEditing(true)}>
                    Edit
                </button>
            )}
        </div>
    );
}

export default Email;
